import { useEffect, useRef, useState } from 'react';
import FilesEdit from './FilesEdit';
import WebUniversal, { CoverHandleDeleteOptions, WUExtendPropsType } from '../system/WebUniversalNewExExExEx'
import { columnsheadId } from '../universal/columnshead';
import { Tooltip, Image, Button, Upload, Space, Select } from 'antd';
import fetchApi from '../../utils/api/fetchApi';
import antMessage from '../../utils/extend/AntdNotification';
import { UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import getList from '../../utilsTsx/universal/getList';
import FileUpload, { UploadFileType } from './FileUpload';
import filesApis, { UploadReturn } from './filesApis';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'files';

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    /** 刷新数据 */
    const [InitData, setInitData] = useState<any>();

    const [filesServerData, setFilesServerData] = useState<any>();
    const [selectedServerId, setSelectedServerId] = useState<string | undefined>(undefined);
    const [serviceData, setServiceData] = useState<any>();
    const [selectedServiceId, setSelectedServiceId] = useState<string | undefined>(undefined);
    const [filesGroupData, setFilesGroupData] = useState<any>();
    const [selectedFilesGroupId, setSelectedFilesGroupId] = useState<string | undefined>(undefined);

    const [uploadOptions, setUploadOptions] = useState<UploadReturn>();



    /** filesService */
    const [filesService, setFilesService] = useState<any>();
    /** 服务id */
    const [serviceId, setServiceId] = useState<any>();

    /**
     * 获取文件组数据
     * @param options 选项
     */
    const getFilesGroupData = async (
        options: {
            /** 服务地址 */
            urlService?: string;
            /** 文件服务器id */
            filesServerId: string;
            /** 服务id */
            serviceId?: string;
        }
    ) => {
        const { urlService = defaultService, filesServerId, serviceId } = options;
        fetchApi.GET(urlService,
            {
                apiId: 'filesGroup',
                apiExtend: 'showList',
                apiData: {
                    sendPageData: {
                        filesServerId,
                        serviceId
                    }
                }
            }).then(res => {
                if (res.success) {
                    setFilesGroupData([{ id: 'allFilesGroup', groupName: '所有' }, ...res.data]);
                    setSelectedFilesGroupId('allFilesGroup')
                }
            })
    };

    /**
     * 获取服务号数据
     * @param options 选项
     */
    const getServiceData = async (options: {
        /** 文件服务器id */
        filesServerId: string;
        /** 服务地址 */
        urlService?: string;
        /** 服务id */
        serviceId?: string;
    }) => {
        const { filesServerId, urlService = defaultService, serviceId } = options;
        console.log("options",options);
        
        fetchApi.GET(urlService,
            {
                apiId: 'filesService',
                apiExtend: 'showList',
                apiData: {
                    sendPageData: {
                        filesServerId
                    }
                }
            }).then(res => {
                if (res.success) {
                    setServiceData(res.data);
                    getFilesGroupData({
                        urlService,
                        filesServerId,
                        serviceId
                    });
                }
            })
    };

    useEffect(() => {
        let urlService: string = '';
        if (ref.current) {
            urlService = ref.current.defaultService;
            console.log("ref.current",ref.current);
            
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'filesServer',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setFilesServerData(res.data);
                    for (const item of res.data) {
                        const { id, isDefault, defaultServiceId } = item;
                        if (isDefault === true) {
                            setSelectedServerId(id);
                            setSelectedServiceId(defaultServiceId);
                            getServiceData({
                                filesServerId: id,
                                urlService,
                                serviceId: defaultServiceId
                            });
                            break;
                        }
                    }
                }
            })
    }, []);

    /**
     * 是否图片
     * @param fileType 文件类型
     * @returns 
     */
    const isImage = (fileType: string) => {
        let returnData = false
        if (fileType.slice(0, 5) === 'image') {
            returnData = true
        }
        return returnData;
    };

    /**
     * 获取文件地址
     * @param record 
     * @param isDownload 是否是下载
     * @returns 
     */
    const getFile = (record: any, isDownload?: boolean) => {
        const { destination, fileName, smallImage, serverUrl } = record;
        const filePath = `${serverUrl}/${destination}/` +
            (isDownload === true ? fileName : (smallImage ? smallImage : fileName));
        return filePath;
    };

    /**
     * 覆盖删除按钮方法
     * @param record 
     */
    const coverHandleDelete = async (options: CoverHandleDeleteOptions) => {
        try {
            const { record } = options;
            //删除文件管理的数据(物理删除)
            const res = await fetchApi.DELETE(
                defaultService,
                {
                    apiId: 'files',
                    apiExtend: 'deleteFiles',
                    apiData: {
                        filesIds: [{ id: record.id }],
                        sendPageData: {
                            filesServerId: selectedServerId,
                            serviceId: selectedServiceId
                        }
                    }
                })
            if (res.success === true) {
                antMessage('success', '删除成功', 'success');
                if (InitData) {
                    InitData();
                }
            }
            else {
                antMessage('error', '删除失败', res.message);
            }
        }
        catch (err: any) {
            antMessage('error', '删除失败', `${err.message}，[${err.errors.status}]`);
        }
    };

    // const fileUpload = () => {
    //     if (selectedServiceId && selectedFilesGroupId) {
    //         filesApis.upload({
    //             filesServerId: selectedServerId,
    //             serviceId: selectedServiceId,
    //             filesGroupId: selectedFilesGroupId,
    //             callback: (res) => {
    //                 console.log(res);
    //                 if (res.success) {
    //                     antMessage('success', '上传成功', 'success');
    //                 } else {
    //                     antMessage('error', '上传失败', res.message);
    //                 }

    //             }
    //         })
    //     } else {
    //         antMessage('error', '上传失败', '请选择服务id与文件组');
    //     }
    // };

    /**
     * 文件更新
     */
    const fileUpdate = (filesId: string) => {
        return {
            name: 'file',
            action: filesService,
            headers: {
                apiId: 'files',
                apiExtend: 'updateSingleFile',
                filesId,
                serviceId
            },
            async onChange(info: any) {
                if (info.file.status === 'uploading') {
                    console.log('uploading');
                    // setWipeRefresh(numberHandle.RangeNumber(1, 999));
                }
                if (info.file.status === 'done') {
                    if (info.file.response.success) {
                        antMessage('success', '文件上传成功', 'success');
                        //刷新
                        // setWipeRefresh(numberHandle.RangeNumber(1, 999));
                        // setRefresh(numberHandle.RangeNumber(1, 999));
                        window.location.reload();
                    }
                    else {
                        antMessage('error', '文件上传失败', info.file.response.message);
                        console.log(info.file);
                    }
                } else if (info.file.status === 'error') {
                    antMessage('error', '文件上传失败', info.file.response.message);
                    console.log(info.file);
                }
            },
        }
    };

    /** 表头内容 */
    const columnsHead = [
        {
            title: '文件组',
            dataIndex: 'filesGroup',
            render: (text: any) => (text.groupName)
        },
        {
            title: '子目录',
            dataIndex: 'subdirectory',
            render: (text: any) =>
                <Tooltip placement="topLeft" title={text}>{
                    text?.length >= 8 ? text?.substring(0, 8) + '......' : text
                }</Tooltip>
        },
        {
            title: '日期目录',
            dataIndex: 'dateSubdirectory',
        },
        {
            title: '名称',
            dataIndex: 'originalFileName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '文件',
            dataIndex: 'fileName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '目录',
            dataIndex: 'destination',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 8) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '有效期',
            dataIndex: 'fileValidityPeriod',
            render: (val: any, record: any) => <Tooltip placement="topLeft" title={val?.id !== 'permanent' ?
                (typeof record.deletionDate !== 'undefined' ? `到期：${dayjs(record.deletionDate).format('YYYY-MM-DD HH:mm:ss')}` : '')
                : undefined}>
                {val?.name}
            </ Tooltip>
        },
        {
            title: '图片',
            dataIndex: 'id',
            render: (text: any, record: any) => (
                isImage(record.fileType) ?
                    < Image
                        src={getFile(record)}
                        width={60}
                        alt="图片" /> :
                    <text>{record.fileType}</text>
            )
        },
        {
            title: '下载',
            dataIndex: 'id',
            render: (text: any, record: any) =>
                <a href={getFile(record, true)} >
                    <Tooltip title={'请用鼠标右键点击下载（另存）！'}>下载</Tooltip></a>
        },
        {
            title: '更新',
            dataIndex: 'id',
            render: (text: any) => (
                <Upload
                    {...fileUpdate(text)}
                    showUploadList={false}>
                    <Button icon={<UploadOutlined onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />}>更新</Button>
                </Upload>
            )
        }
    ];

    /** 图库表头内容 */
    const galleryColumns = [
        {
            dataIndex: 'id',
            render: (text: any, record: any) => (
                isImage(record.fileType) ?
                    < Image
                        src={getFile(record)}
                        height={150}
                        alt="图片" /> :
                    <text>{record.fileType}</text>
            )
        },
        {
            dataIndex: 'id',
            render: (text: any, record: any) => {
                return (
                    <Button type='primary'>选择</Button>
                )
            }
        }];

    /** 表头 */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /** 扩展Props */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '文件',
        apiId,
        columns,
        galleryColumns,
        showStates: true,
        showAdd: false,
        displayMode: 'both',
        EditComponent: FilesEdit,
        coverHandleDelete,
    };

    return (
        <> <Space>
            <Select
                showSearch
                placeholder="服务器"
                optionFilterProp="children"
                value={selectedServerId}
                onChange={async (e, option: any) => {
                    await getServiceData({
                        filesServerId: e
                    })
                    setSelectedServerId(e);
                    const { defaultServiceId } = option?.item;
                    setSelectedServiceId(defaultServiceId);
                    InitData({
                        apiId,
                        sendPageData: {
                            filesServerId: e,
                            serviceId: defaultServiceId,
                            filesGroupId: 'allFilesGroup'
                        }
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(filesServerData, {
                    itemName: 'serverName'
                })}
            </Select>
            <Select
                showSearch
                placeholder="服务号"
                optionFilterProp="children"
                value={selectedServiceId}
                onChange={(e) => {
                    setSelectedServiceId(e);
                    getFilesGroupData({
                        filesServerId: selectedServerId!,
                        serviceId: e
                    })
                    InitData({
                        apiId,
                        sendPageData: {
                            filesServerId: selectedServerId,
                            serviceId: e,
                            filesGroupId: 'allFilesGroup'
                        }
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(serviceData, {
                    itemName: 'serviceName'
                })}
            </Select>
            <Select
                showSearch
                placeholder="文件组"
                optionFilterProp="children"
                value={selectedFilesGroupId}
                onChange={(e) => {
                    setSelectedFilesGroupId(e);
                    InitData({
                        apiId,
                        sendPageData: {
                            filesServerId: selectedServerId,
                            serviceId: selectedServiceId,
                            filesGroupId: e
                        }
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(filesGroupData, {
                    itemName: 'groupName'
                })}
            </Select>
            {/* <Button disabled={selectedFilesGroupId === 'allFilesGroup'} onClick={() => fileUpload()}>上传图片</Button> */}
            <FileUpload
                uploadOptions={{
                    filesServerId: selectedServerId,
                    serviceId: selectedServiceId!,
                    filesGroupId: selectedFilesGroupId!
                }}
                disabled={selectedFilesGroupId === 'allFilesGroup'}
                onUploadSuccess={(file) => {
                    antMessage('success', '文件上传成功', 'success');
                    if (InitData) {
                        InitData();
                    }
                }}
                // value={fileList}
                // onChange={setFileList}
                buttonText="上传文件"
            />
        </Space>
            <> </>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;